<template>
<div class="limiter">
		<div class="container-login100">
			<div class="wrap-login100 p-l-50 p-r-50 p-t-20 p-b-30">
				<form class="login100-form validate-form">
					<span class="login100-form-title p-b-15">
					    <img src="assets/images/wbl/logo-NewParisian-512x145px-final.png" alt="新巴黎人" class="p-b-5" width="100%" />
                        {{lang.login}}
                    </span>
                        <div class="language wrap-input100 validate-input m-b-10">
                        {{lang.login_select}}: 
                        <select id="select" class="input100 lnr-language"  @change="changeLanguage(selectedLang)" v-model="selectedLang" >
                            <option value="2" selected>简体中文</option>
                            <option value="3">繁體中文</option>
                            <option value="1">English</option>
                        </select>
                        </div>
					
					<div class="wrap-input100 validate-input m-b-10">
						
						
						<input class="input100" type="text" id="username"  :maxlength="inputLength.username" v-model="formData.accname"  :placeholder="langList.login['LOGIN.LBL_LOGIN']">
						<span class="focus-input100"></span>
						<span class="symbol-input100">
							<span class="lnr lnr-user"></span>
						</span>
					</div>

					<div class="wrap-input100 validate-input m-b-10">
						<input class="input100" type="password"  :maxlength="inputLength.password" size="20" v-model="formData.pass" :placeholder="langList.login['LOGIN.PASSWORD']">
						<span class="focus-input100"></span>
						<span class="symbol-input100">
							<span class="lnr lnr-lock"></span>
						</span>
					</div>
					<div class="container-login100-form-btn p-t-10">
						<button class="login100-form-btn" @click.prevent="login()">
							{{lang.login}}
						</button>
					</div>



					<!--<div class="text-center w-full p-t-115">
						<span class="txt1">
							Not a member?
						</span>

						<a class="txt1 bo1 hov1" href="#">
							Sign up now							
						</a>
					</div>-->
				</form>
			</div>
		</div>
	</div>
    <!--div>
        <popupFestival></popupFestival>
        <form action="" method="post" name="myForm" target="_self" autocomplete="off">
        <div id="login">
            <ul id="language">
                    <li>
                        <a id="lag" href="#"><span :id="languageIcon()"></span><font>{{langSelect[selectedLang]['caption']}}</font><font v-if="selectedLang == '2' || selectedLang == '3'">中文</font><span id="triangle"></span></a>
                        <ul>
                            <li @click="changeLanguage(3)"><a id="lag2" ><span id="icon-hk"></span><font>{{langSelect[3].caption}}中文</font></a></li>
                            <li @click="changeLanguage(2)"><a id="lag2" ><span id="icon-cn"></span><font>{{langSelect[2].caption}}中文</font></a></li>
                            <li @click="changeLanguage(1)"><a id="lag2" ><span id="icon-en"></span><font>{{langSelect[1].caption}}</font></a></li>
                        </ul>
                    </li>
            </ul>

            <div id="middle">
            
                <div id="account">
                <ul style="list-style-type:none; margin:0px; padding:0px;">
                    <li id="tab">
                        <input type="text" id="username" size="20" :maxlength="inputLength.username" v-model="formData.accname" :placeholder="langList.login['LOGIN.LBL_LOGIN'] "/>
                    </li>
                    </ul>
                </div>
            
                <div id="password">
                <ul style="list-style-type:none; margin:0px; padding:0px;">
                    <li id="tab">
                        <input type="password"  :maxlength="inputLength.password" size="20" v-model="formData.pass" :placeholder="langList.login['LOGIN.PASSWORD']"/>
                    </li>
                    </ul>
                </div>
            <a href="#" @click.prevent="login()"><div id="enter"></div></a>
            
        </div>
        </div>
        </form>
    </div-->
</template>
<script>
import popupFestival from '../../components/popup-festival'
import authCommon from '../../mixins/authCommon'
export default {
  mixins: [authCommon],
    components: {
      popupFestival,
    },
    data() {
        return {
        companyName: window._companyname,
        selectedLang: null,
        langSelect: lang_select,
        cookielang: _cookie,
        lang: lang,
        langList: window.langList,
        formData: {
            accname: "",
            pass: ""
        },
        error: {
            loginIdReq: false,
            message: ""
        },
        sportList: _.keyBy(window._sportList, 'id'),
        sprtEvents: window._sportEventList ? window._sportEventList : [],
        hotMatchList: [],
        companycode: window.compcode,
        currentTemplate: window._currentTemplate,
        customTemplate: window._customTemplate,
        token :window.token,
        };
    },
    methods: {
        languageIcon(){
            if(this.selectedLang == "1"){
                return "icon-en"
            }else if(this.selectedLang == '2'){
                return "icon-cn"
            }else{
                return "icon-hk"
            }
        },
        logoSwitch(){
            if(this.cookielang == 'en_US'){
                return 'assets/images/eng_3sing.png'
                //return 'assets/images/3Sing-Logo-en.png'
            }
            return 'assets/images/3sing.png'
            //return 'assets/images/3Sing-Logo-cn.png'
        },
        changeLanguage: function(value) {
            this.$ajax({
                url: "",
                type: "get",
                data: {
                language: value
                }
            }).then(response => {
                window.location.reload();
            });
        },
        login() {
            if (this.formData.accname == "") {
                this.error.loginIdReq = true;
                this.error.message = this.lang.emptyLoginId;
                alert(this.error.message)
            } else if (this.formData.pass == "") {
                this.error.loginIdReq = true;
                this.error.message = this.lang.emptyPassword;
                alert(this.error.message)
            } else {
                this.error.loginIdReq = false;
                this.formData.token = token.arr_9+'|'+this.formData.accname
                this.$ajax({
                method: "post",
                url: "",
                data: this.formData
                }).catch(error => {
                this.error.loginIdReq = true;
                this.error.message = error.responseJSON.message;
                alert(this.error.message)
                });
            }
        },
    },
    mounted() {
        this.selectedLang = _.findKey(this.langSelect, {
        language_code: this.cookielang
        });
        $('#username').focus();
    }
}
</script>
<style lang="scss">
@import "~@/styles/base/global"; 
@import "~@/styles/auth/wbl";
</style>



// WEBPACK FOOTER //
// resources/mhg/vue/apps/auth/wbl.vue